<template>
    <div class="">
        <div v-if="tabContent.content1" class="row">
            <div class="col-12 col-xl-3 mb-4 mb-xl-0">
                <div v-if="tabContent.contentTitle1">
                    <h5>
                        {{ tabContent.contentTitle1 }}
                    </h5>
                </div>
                <div v-else-if="globals.formationTabsTitleSections.formationTabSectionTitle.title01">
                    <h5>
                        {{ globals.formationTabsTitleSections.formationTabSectionTitle.title01 }}
                    </h5>
                </div>
            </div>

            <div class="col-12 col-xl-8">
                <div class="text-editor" v-html="tabContent.content1"></div>

                <div v-if="tabContent.imageId" class="mt-5">
                    <div v-if="tabContent.imageUrl != ''">
                        <a :href="tabContent.imageUrl" target="_blank">
                            <AssetLoader :asset="{ asset: tabContent.imageId }" />
                        </a>
                    </div>
                    <div v-else>
                        <AssetLoader :asset="{ asset: tabContent.imageId }" />
                    </div>

                    <div v-if="tabContent.imageCaption" class="formation-img-caption">
                        {{ tabContent.imageCaption }}
                    </div>
                </div>

                <div class="sep-hor-thick-black mt-5 mb-5"></div>
            </div>
        </div>
        <div v-if="tabContent.content2" class="row">
            <div class="col-12 col-xl-3 mb-4 mb-xl-0">
                <div v-if="tabContent.contentTitle2">
                    <h5>
                        {{ tabContent.contentTitle2 }}
                    </h5>
                </div>
                <div v-else-if="globals.formationTabsTitleSections.formationTabSectionTitle.title02">
                    <h5>
                        {{ globals.formationTabsTitleSections.formationTabSectionTitle.title02 }}
                    </h5>
                </div>
            </div>
            <div class="col-12 col-xl-8">
                <div class="text-editor" v-html="tabContent.content2"></div>
            </div>
        </div>

        <div v-if="tabContent && tabContent.accordion && tabContent.accordion.length > 0" class="row padding-container-top">
            <div id="accordion-top" class="col-12 col-xl-11">
                <div class="accordion accordion-flush" :id="'accordion-formation-' + tabIndex">
                    <div
                        v-for="(accordion, indexAccordion) in tabContent.accordion"
                        :key="'accordion' + tabIndex + indexAccordion"
                        class="accordion-item"
                    >
                        <h3
                            class="accordion-header"
                            :id="'accordion-header-' + tabIndex + indexAccordion"
                        >
                            <button
                                class="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                :data-bs-target="'#accordion-content-' + tabIndex + indexAccordion"
                                aria-expanded="false"
                                :aria-controls="'accordion-content-' + tabIndex + indexAccordion"
                            >
                                {{ accordion.title }}
                            </button>
                        </h3>

                        <div
                            :id="'accordion-content-' + tabIndex + indexAccordion"
                            class="accordion-collapse collapse"
                            :aria-labelledby="'accordion-header-' + tabIndex + indexAccordion"
                            :data-bs-parent="'#accordion-formation-' + tabIndex"
                        >
                            <div class="accordion-body text-editor" v-html="accordion.body"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import AssetLoader from '@/components/helpers/AssetLoader'

export default {
    name: 'FormationTabContent',
    components: {
        AssetLoader,
    },
    // On loaded...
    mounted() {
        const accordionItems = document.querySelectorAll('.accordion-collapse')
        const acc = document.getElementById('accordion-top')

        accordionItems.forEach((el)=>{
            el.addEventListener('shown.bs.collapse',()=>{
                var scrollOffset = (acc.scrollTop + el.parentNode.offsetTop)
                window.scrollTo(0, scrollOffset);
            })
        })
    },

    props: {
        tabContent: {
            type: Object,
            required: true,
        },
        tabIndex: {
            type: Number,
            required: true,
        },
        formateurs: {
            type: Array,
            required: false,
        },
        formateursDefaultImg: {
            type: Object,
            required: true,
        },
    },
    computed: {
        pageIsLoaded() {
            return this.contentIsLoaded && this.globalsIsLoaded
        },
        ...mapState(['contentIsLoaded', 'globalsIsLoaded']),
        ...mapGetters(['seo', 'content', 'globals']),
        orderedFormateurs() {
            if(!this.formateurs) {
                return []
            }
            const formateursList = [...this.formateurs]
            return formateursList.sort((a, b) => {
                return a.original.order - b.original.order
            })
        },

    },
    methods: {
        ...mapActions(['setErrorsReportMsg']),
    },
}
</script>
